/*
 * Copyright (c) Nexign, JSC, 2020.
 */

/**
 * Constants for Calls Detail
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.4.0
 * @since 1.4.0
 */

export const CALLS_DETAIL_PRICE = 0;

export enum ECallsDetailSteps {
    Prepare = 'PrepareStep',
    Final = 'ConfirmStep',
}

export enum ECallsDetailStepValidationCodes {
}

/*
* -------------------------------------------
*           ACTIONS
* -------------------------------------------
*/

export const CALLS_DETAIL_VALIDATE_START = '@@b2b_portal_ui/callsDetail/VALIDATE_START';
export const CALLS_DETAIL_SET_IS_STEP_VALID = '@@b2b_portal_ui/callsDetail/SET_IS_STEP_VALID';

export const CALLS_DETAIL_STORAGE_SAVE = '@@b2b_portal_ui/callsDetail/STORAGE_SAVE';

export const CALLS_DETAIL_SET_PARAMS = '@@b2b_portal_ui/callsDetail/SET_PARAMS';

export const CALLS_DETAIL_HANDLE_NEXT = '@@b2b_portal_ui/callsDetail/HANDLE_NEXT';
